import { createIcon } from './utils';

const CloseLine = createIcon(
  'CloseIcon',
  'M12.5 10.726 16.955 6.271 18.228 7.544 13.773 12 18.228 16.455 16.955 17.728 12.5 13.273 8.045 17.728 6.772 16.455 11.227 12 6.772 7.544 8.045 6.271 12.5 10.726Z'
);

export default CloseLine;
